import k from '../k'
import addRobot from '../parts/addRobot'
import addUI from '../parts/addUI'
import addVoid from '../parts/addVoid'

k.loadSprite('small-grass', 'sprites/grass.png')

export default () => {
  k.setGravity(1000)
  k.add([k.sprite('background'), k.fixed()])

  const { partDisplay } = addUI(1)

  const robot = addRobot(true, partDisplay)
  const tooltipE = robot.add([k.sprite('e'), k.anchor('bot'), k.pos(0, -12)])
  tooltipE.hidden = true

  addVoid(250)

  const grass = k.add([
    k.sprite('grass'),
    k.pos(-20, 20),
    k.body({ isStatic: true }),
    k.area()
  ])

  k.add([
    k.sprite('small-grass'),
    k.pos(250, 30),
    k.body({ isStatic: true }),
    k.area()
  ])

  k.add([
    k.sprite('small-grass'),
    k.pos(390, 40),
    k.body({ isStatic: true }),
    k.area()
  ])

  const grassFinal = k.add([
    k.sprite('grass'),
    k.pos(530, 50),
    k.body({ isStatic: true }),
    k.area()
  ])

  grass.add([
    k.text('Press X to recharge', {
      font: 'pixel',
      size: 12
    }),
    k.color(57, 44, 49),
    k.pos(60, -20)
  ])

  const door = grassFinal.add([
    k.sprite('door'),
    k.pos(200, 0),
    k.area(),
    k.anchor('bot'),
    k.z(-1),
    'door'
  ])

  let atDoor = false
  let doorOpen = false

  robot.onCollide('door', () => {
    atDoor = true
    tooltipE.hidden = false
  })
  robot.onCollideEnd('door', () => {
    atDoor = false
    tooltipE.hidden = true
  })
  robot.onKeyPress('e', () => {
    if (atDoor && !doorOpen) {
      doorOpen = true
      door.play('open')
    } else if (atDoor && doorOpen) {
      k.go('two')
    }
  })
}
